import cartItemsHtml from './cartitems.component.html';
import './cartitems.component.scss';

class CartItemsController {
    constructor($scope, CartService) {
        'ngInject';
        this.service = CartService;
        this.$scope = $scope;

        this.$scope.keyLength = function (obj) {
            return Object.keys(obj).length;
        }
    }

    $onInit() {
        if (!this.service.loaded && !this.service.loading) {
            this.service.load().then(() => {
                console.log()
            });
        }
    }

    decreaseQuantity(cartItem) {
        if (parseInt(cartItem.quantity) < 1) return;

        this.changeQuantity(cartItem, parseInt(cartItem.quantity) - 1);
    }

    increaseQuantity(cartItem) {
        this.changeQuantity(cartItem, parseInt(cartItem.quantity) + 1);
    }

    changeQuantity(cartItem, quantity) {
        if (quantity < 0) return;

        cartItem.quantity = parseInt(quantity);

        if (quantity == 0) {
            this.removeItem(cartItem);
            return;
        }

        this.service.changeQuantity(cartItem);
    }

    removeItem(cartItem) {
        this.service.removeItem(cartItem);
    }
}

let cartItemsComponent = {
    bindings: {},
    template: cartItemsHtml,
    controller: CartItemsController
}

export default cartItemsComponent;
